<template>
  <nav class="main-menu" id="side-menu">
    <ul class="menu__items">
      <main-menu-item v-for="menuItem in availableMenuItems" :key="menuItem.id" v-bind="menuItem"></main-menu-item>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';

import MainMenuItem from './MainMenuItem';

export default {
  name: 'MainMenu',

  components: {
    MainMenuItem,
  },

  data() {
    return {
      menuItems: [
        {
          id: 'manage-teachers',
          to: 'teachers',
          icon: ['fas', 'user-friends'],
          label: 'Teachers',
        },
        {
          id: 'learner-router-link',
          to: 'learners',
          icon: ['fas', 'users'],
          label: 'Learners',
        },
        {
          id: 'reports-router-link',
          to: 'reports',
          icon: ['fas', 'chart-bar'],
          label: 'Reports',
          children: [
            {
              id: 'overview-router-link',
              to: 'reports.overview',
              label: 'Overview',
            },
            {
              id: 'live-instruction-router-link',
              to: 'reports.live_instruction',
              label: 'Live Instruction',
            },
            {
              id: 'session-router-link',
              to: 'reports.session',
              label: 'Session Report',
            },
            {
              id: 'course-router-link',
              to: 'reports.units_and_courses',
              label: 'Units and Courses',
            },
            {
              id: 'vpa-router-link',
              to: 'reports.vpa',
              label: 'VPA',
            },
          ],
        },
        {
          id: 'all-classes-router-link',
          to: 'all_classes',
          icon: ['fas', 'chalkboard-teacher'],
          label: 'All Classes',
        },
        {
          id: 'schedule-router-link',
          to: 'my_schedule',
          icon: ['far', 'calendar'],
          label: 'My Schedule',
          children: [
            {
              id: 'my-calendar-link',
              to: 'my_calendar',
              label: 'My Availability',
            },
          ],
        },
        {
          id: 'lessons-router-link',
          to: 'lessons',
          icon: ['fa', 'book'],
          label: 'Lessons',
          children: [
            {
              id: 'share-history-router-link',
              to: 'lessons.share_history',
              label: 'Share History',
            },
          ],
        },
        {
          id: 'settings-router-link',
          to: 'my_settings',
          icon: ['fas', 'cog'],
          label: 'My Settings',
        },
      ],
    };
  },

  computed: {
    ...mapGetters('features', ['hasAccessTo']),

    availableMenuItems() {
      return this.filterItems(this.menuItems);
    },
  },

  methods: {
    filterItems(items) {
      return items
        .filter(item => this.hasAccessTo(item.to))
        .map(item => ({
          ...item,
          ...(item.children ? { children: this.filterItems(item.children) } : {}),
        }));
    },
  },
};
</script>

<style lang="scss" scoped>
.main-menu {
  font-size: 18px;
  flex: auto;
  width: 100%;
  margin-top: 25px;

  &__items {
    margin: 0;
  }
}
</style>
